import type { CSSProperties } from 'react';
import { timecode } from '../lib/mediaReview';

export function FramePosition({frame, total, time, title}: {frame?: number; total?: number; time: number; title?: string}) {
  return <div className="review-frame-position" title={title} style={{'--frame-digits':Math.max(1,String(total || frame || 1).length)} as CSSProperties}>
    <div data-testid="video-frame"><span>Кадр </span><strong>{frame || '—'}</strong><span> / </span><span className="review-frame-total">{total || '—'}</span></div>
    <output data-testid="video-time">{timecode(time)}</output>
  </div>;
}
